import { Star } from 'lucide-react';

export const CategoryChip = ({ category }) => (
  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-brand-teal/8 text-brand-teal text-xs font-semibold">
    {category}
  </span>
);

export const GooderaPick = ({ className = '' }) => (
  <span
    data-testid="goodera-pick-chip"
    className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-brand-teal text-white text-xs font-bold ${className}`}
  >
    <Star size={11} fill="currentColor" strokeWidth={0} />
    Goodera pick
  </span>
);
